module.exports = __webpack_public_path__ + "img/velopic.a60ed06a.jpg";